import { render, staticRenderFns } from "./yaodian.vue?vue&type=template&id=163af80a&scoped=true&"
import script from "./yaodian.vue?vue&type=script&lang=js&"
export * from "./yaodian.vue?vue&type=script&lang=js&"
import style0 from "./yaodian.vue?vue&type=style&index=0&id=163af80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163af80a",
  null
  
)

export default component.exports